import { getUrlParamsFetch, urlBackend } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import {
  IDataPlanificacionParams,
  IPlanification,
  IPlanificationBlock,
  IPlanificationUnblock,
} from '@/shared/interfaces';
import { IFechasDisponible } from '@/shared/interfaces/erp/system-settings/horas-libres-flota.interface';
import {  useQuery } from '@tanstack/react-query';

const { get, post } = erpApi();

//OBTENER PLANIFICACIONES POR FLOTA
export const useFetchPlanification = (params?: IDataPlanificacionParams) => {
  return useQuery({
    queryKey: ['planification', ...Object.values(params || '')],
    queryFn: async () => {
      return getPlanification(params);
    },
  });
};

export const getPlanification = async (params?: IDataPlanificacionParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<IPlanification>(
    `${urlBackend}api/v1/planificador/?${queryParams}`,
    true
  );
  return resp;
};

export const putPlanificationBlock = async (data: IPlanificationBlock) => {
  const res = await post<IFechasDisponible[]>(
    `${urlBackend}api/v1/planificador-bloquear-horas/`,
    data,
    true
  );
  return res;
};

export const postPlanificatioUnblock = async (params: IPlanificationUnblock) => {
  return post<IFechasDisponible[]>(
    `${urlBackend}api/v1/planificador-desbloquear-horas/`,
    params,
    true
  );
};
